'use strict';

var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
var minChars = 3;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
let triggeredBySearchButton = false;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('body').removeClass('overflow-hidden');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 */
function applyModals() {
    $('body').addClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'true');
    $('body').addClass('overflow-hidden');
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (window.matchMedia('(max-width: 992px)').matches) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $(response).spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).attr('aria-expanded', 'true');
        positionSuggestions(this);

        if (window.matchMedia('(max-width: 992px)').matches) {
            applyModals();
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var $form = $(this).closest('form');
        var suggestionsList = $form.find('.suggestions .item');

        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $(this).attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if (!endpoint) {
        return;
    }

    if ($(scope).val().length >= minChars) {
        $(scope).parent()
            .find('.suggestions')
            .spinner()
            .start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $(scope).parent()
                        .find('.suggestions')
                        .spinner()
                        .stop();
            }
        });
    } else {
        clearModals();
        getSuggestionsWrapper(scope).empty();
        $(scope).attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var $form = $(this).closest('form');
    var suggestionsList = $form.find('.suggestions .item');

    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeAttr('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

var toggleModalBool;

/**
 * Toggle modal classes for mobile
 */
function toggleModalClasses() {
    if (window.matchMedia('(max-width: 992px)').matches && $('.suggestions:visible').length > 0) {
        if (!toggleModalBool) {
            applyModals();
            toggleModalBool = true;
        }
    } else if (!window.matchMedia('(max-width: 992px)').matches && $('.suggestions-wrapper').length === 0) {
        if (toggleModalBool || toggleModalBool === undefined) {
            clearModals();
            toggleModalBool = false;
        }
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        if (Window.BrTrk) {
            try {
                var searchData = {};
                searchData.q = document.forms.simpleSearch.elements.q.value;
                if (searchData.q && searchData.q.trim().length > 0) {
                    Window.BrTrk.getTracker().logEvent('suggest', 'submit', searchData, {}, true);
                }
            } catch (error) {
                console.log('Error while sending tracking data');
            }
        }

        var $form = $(this).closest('form');
        var suggestionsList = $form.find('.suggestions .item');

        $(this).spinner().start();
        if (!triggeredBySearchButton && suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
        triggeredBySearchButton = false;
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow.call(this, DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow.call(this, DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });

        $(this).on('keydown', function (e) {
            if (e.which === 13) { // Enter key
                var $form = $(this).closest('form');
                var suggestionsList = $form.find('.suggestions .item');

                if (suggestionsList.length > 0 && suggestionsList.filter('.selected').length === 0) {
                    // No suggestion selected → allow form submit
                    e.preventDefault();
                    $(this).closest('form').submit();
                }
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field') && $('.suggestions:visible').length > 0) {
            e.preventDefault();
            clearModals();
            $('.suggestions').hide();
            $('input.search-field').attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
        }
    });

    $('.site-search .reset-button').on('click', function () {
        clearModals();
        $('.suggestions').hide();
        $('input.search-field').attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
        tearDownSuggestions();
    });

    $('body').on('click focus touchstart', '.suggestions', function () {
        $('input.search-field').trigger('blur');
    });

    $('body').on('click', '.search-button', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        var query = $form.find('input.search-field').val().trim();

        if (query.length >= 1) {
            triggeredBySearchButton = true;
            $form.trigger('submit');
        }
    });

    $(window).resize(function () {
        toggleModalClasses();
    });
};
